import React, { useState } from 'react'
import AnimateHeight from 'react-animate-height'
import { isArray, isEmpty, map } from 'lodash'

import CaretUp from '../../assets/icons/caret-up.svg'
import CaretDown from '../../assets/icons/caret-down.svg'

const FeatureAccordion = ({ feature, twoCols }) => {
  const [height, setHeight] = useState(0)
  if (!feature || !feature?.details || isEmpty(feature?.details)) return null
  const { title, icon, details } = feature

  function onToggle() {
    setHeight((currentHeight) => (currentHeight === 0 ? 'auto' : 0))
  }

  return (
    <div className="feature-accordion">
      <div className="feature-accordion__btn" role="button" onClick={onToggle}>
        <div>
          <img className="icon__feature" src={icon} alt={title} />
          <span>{title}</span>
        </div>
        <img
          className="icon__up-down"
          src={height === 0 ? CaretDown : CaretUp}
          alt={title}
        />
      </div>
      <AnimateHeight height={height}>
        <div
          className={`feature-accordion__details ${
            twoCols ? 'two-cols' : 'one-col'
          }`}
        >
          {isArray(details) ? (
            map(details, (detail, index) => (
              <span dangerouslySetInnerHTML={{ __html: detail }} key={index} />
            ))
          ) : (
            <span dangerouslySetInnerHTML={{ __html: details }} />
          )}
        </div>
      </AnimateHeight>
    </div>
  )
}

export default FeatureAccordion
